<payment-summary 
  *ngIf="showPayment" 
  [showpaymentsummary]="showPayment"
  [invoiceDetailById]="getInvoiceById$" 
  (closeSidePopup)="ClosePaymentSummary($event)">
</payment-summary>


<payment-status-timeline 
  *ngIf="showPaymentStatusTimeLine" 
  [visible]="showPaymentStatusTimeLine" 
  [uuid]="uuid"
  [isPayment]="ispayment" 
  (GoToClientSubscription)="GoToClientDetails($event)">
</payment-status-timeline>